import { Chip } from "@mui/joy";

export const ISSUE_STATUS = {
    NOT_AN_ISSUE: "Not an issue",
    FORWARD_TO_DESIGN_TEAM: "Forward to design team",
    FORWARD_TO_SUB: "Forward to sub",
    RESOLVED_PENDING_REVISION: "Resolved, pending revision",
    CLOSED: "Closed",
    OPEN: "Open",
} as const;

export type IssueStatus = typeof ISSUE_STATUS[keyof typeof ISSUE_STATUS];

const config: Record<
    IssueStatus,
    {
        color: "success" | "primary" | "warning" | "neutral" | "danger";
        defaultLabel: string;
    }
> = {
    "Not an issue": {
        color: "neutral",
        defaultLabel: "Not an issue",
    },
    "Forward to design team": {
        color: "primary",
        defaultLabel: "Forward to design team",
    },
    "Forward to sub": {
        color: "warning",
        defaultLabel: "Forward to sub",
    },
    "Resolved, pending revision": {
        color: "success",
        defaultLabel: "Resolved, pending revision",
    },
    Closed: {
        color: "success",
        defaultLabel: "Closed",
    },
    Open: {
        color: "danger",
        defaultLabel: "Open",
    },
};

interface IssueStatusChipProps {
    status: IssueStatus;
    label?: string;
}

export const IssueStatusChip = ({ status, label }: IssueStatusChipProps) => {
    const { color, defaultLabel } = config[status];

    return (
        <Chip variant="soft" size="sm" color={color} sx={{ textTransform: "capitalize" }}>
            {label ?? defaultLabel}
        </Chip>
    );
};
